import { z } from 'zod'

export const versionCheckRequestSchema = z.object({
  version: z.string().min(1),
  build: z.string().optional(),
})

export const versionCheckResponseSchema = z.object({
  supported: z.boolean(),
  updateAvailable: z.boolean(),
  installUrl: z.string().optional(),
  latestVersion: z.string().optional(),
  minimumVersion: z.string().optional(),
  releaseNotes: z.string().optional(),
})
